import { ProtectedRoute } from 'components/protectedRoute/protectedRoute.component';
import { FEATURE } from "data/features.data";
import { BuildingPage } from "pages/building/building.page";
import { BuildingGroupPage } from "pages/buildingGroup/buildingGroup.page";
import { BuildingGroupsPage } from "pages/buildingGroups/buildingGroups.page";
import { BuildingsPage } from "pages/buildings/buildings.page";
import { ChooseCompanyPage } from "pages/chooseCompany/chooseCompany.page";
import { CompaniesPage } from "pages/companies";
import { CompanyPage } from "pages/company/company.page";
import { DashboardPage } from "pages/dashboard/dashboard.page";
import { ForbiddenPage } from "pages/forbidden/forbidden.page";
import { ForgotPasswordPage } from "pages/forgotPassword";
import { GraphicPage } from "pages/graphic/graphic.page";
import { IndicatorPage } from "pages/indicator/indicator.page";
import { IndicatorsPage } from "pages/indicators/indicators.page";
import { NotFoundPage } from "pages/notFound";
import { PendingRecordsPage } from 'pages/pendingRecords/pendingRecords.page';
import { ReservationReportPage } from 'pages/reports/reservationReport/reservationReport.page';
import { ReportsPage } from "pages/reports/singleIndicatorReport/reports.page";
import { SigninPage } from "pages/signin";
import { UpdatePasswordPage } from "pages/updatePassword";
import { UserPage } from "pages/user/user.page";
import { UsersPage } from "pages/users/users.page";
import { useParams } from "react-router-dom";
import { Navigate } from "services/navigation.service";
import { GraphicPage as SantanderGraphicPage } from 'pages/graphic/graphic.santander.page';
import { DashboardPage as SantanderDashboardPage } from 'pages/dashboard/dashboard.santander.page';
import { AreasPage } from 'pages/areas/areas.page';
import { RoomsPage } from 'pages/rooms/rooms.page';
import { AreaPage } from 'pages/area/area.page';
import { RoomPage } from 'pages/room/room.page';
import { AlertsPage } from 'pages/alerts/alerts.page';
import { IndicatorRangeAlertConfigsPage } from 'pages/alertConfigs/indicatorRangeAlertConfigs.page';
import { IndicatorRangeAlertConfigPage } from 'pages/alertConfig/indicatorRangeAlertConfig.page';
import { RoomReservationsPage } from 'pages/roomReservations/roomReservations.page';
import { RoomReservationPage } from 'pages/roomReservation/roomReservation.page';
import { DashboardType } from 'data/dashboardType.data';
import { DashboardRoomOccupationPage } from 'pages/dashboard/dashboard.roomOccupation.page';
import { DashboardRoomSantanderPage } from 'pages/dashboard/santander/room/dashboard.room.santander.page';
import { DashboardRestaurantSantanderPage } from 'pages/dashboard/santander/restaurant/dashboard.restaurant.santander.page';
import { OccupationReportPage } from 'pages/reports/roomOccupationReport/roomOccupationReport.module';
import { RestaurantOccupationReportPage } from 'pages/reports/restaurantReport/restaurantReport.module';
import { RestaurantGraphicPage } from 'pages/graphic/restaurant.graphic.santander.page';
import { RoomOccupationMonthReportPage } from 'pages/reports/roomOccupationMonthReport/roomOccupationMonthReport.module';
import { OccupationPerMonthAdminReportPage } from 'pages/reports/roomOccupationPerMonthAdminReport/roomOccupationPerMonthAdminReport.module';
import { DashboardPainelRestaurantSantanderPage } from 'pages/dashboard/santander/painelRestaurant/dashboard.restaurant.santander.page';
import { VisitantesRestauranteReportPage } from 'pages/reports/visitantesRestauranteReport/visitantesRestauranteReport.module';

export const routes = [
    {
        path: '/login',
        element: <SigninPage />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/signin',
        element: <Navigate to="/login" replace />,
        errorElement: <NotFoundPage />
    },
    {
        //arotech.app/signin/brookfield
        path: '/signin/:companySlug',
        element: <Navigate to="/login" replace />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/forgot-password',
        element: <ForgotPasswordPage />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/redefinir-senha',
        element: <UpdatePasswordPage />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/nao-autorizado',
        element: <ProtectedRoute><ForbiddenPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/:companyId/nao-autorizado',
        element: <ProtectedRoute><ForbiddenPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/escolha-empresa',
        element: <ProtectedRoute features={[FEATURE.BUILDING_CHOOSE_COMPANY.id]}><ChooseCompanyPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/',
        element: <HomeElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/:companyId',
        element: <HomeElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/pendencia-lancamentos',
        element: <PendingRecordsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/pendencia-lancamentos',
        element: <PendingRecordsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/dashboard',
        element: <DashboardElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/dashboard',
        element: <DashboardElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/dashboard/:dashboardId',
        element: <DashboardElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/dashboard/:dashboardId',
        element: <DashboardElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/empresas',
        element: <ProtectedRoute features={[FEATURE.COMPANY_LIST.id]}><CompaniesPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/empresas',
        element: <ProtectedRoute features={[FEATURE.COMPANY_LIST.id]}><CompaniesPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/empresa/:companyId',
        element: <CompanyElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/empresa',
        element: <ProtectedRoute features={[FEATURE.COMPANY_CREATE.id, FEATURE.COMPANY_READ.id]}><CompanyPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/predios',
        element: <ProtectedRoute features={[FEATURE.BUILDING_LIST.id]}><BuildingsPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/predios',
        element: <ProtectedRoute features={[FEATURE.BUILDING_LIST.id]}><BuildingsPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/predio/:buildingId',
        element: <BuildingElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'predio',
        element: <ProtectedRoute features={[FEATURE.BUILDING_CREATE.id, FEATURE.BUILDING_READ.id]}><BuildingPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grupo-de-predios/:buildingGroupId',
        element: <BuildingGroupElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grupo-de-predios',
        element: <BuildingGroupElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'grupos-de-predios/:buildingGroupId',
        element: <BuildingGroupElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grupos-de-predios',
        element: <BuildingGroupsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'grupos-de-predios',
        element: <BuildingGroupsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'usuarios',
        element: <UsersElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/usuarios',
        element: <UsersElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'usuario',
        element: <ProtectedRoute><UserPage /></ProtectedRoute>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'usuario/:userId',
        element: <UserElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/usuario/:userId',
        element: <UserElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastros/:indicatorId',
        element: <IndicatorsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'cadastros/:indicatorId',
        element: <IndicatorsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastro/:indicatorId',
        element: <IndicatorElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastro/:indicatorId/:indicatorRecordId',
        element: <IndicatorElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/:reportId',
        element: <ReportsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/:reportId',
        element: <ReportsElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/reserva-sala',
        element: <ReservationReportElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/reserva-sala',
        element: <ReservationReportElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/ocupacao-sala',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={OccupationReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/ocupacao-sala',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={OccupationReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/ocupacao-sala-mensal',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={RoomOccupationMonthReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/ocupacao-sala-mensal',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={RoomOccupationMonthReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/ocupacao-sala-mensal-admin',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={OccupationPerMonthAdminReportPage} features={[FEATURE.ADMIN_REPORT_VIEW.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/ocupacao-sala-mensal-admin',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={OccupationPerMonthAdminReportPage} features={[FEATURE.ADMIN_REPORT_VIEW.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/ocupacao-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={RestaurantOccupationReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/ocupacao-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={RestaurantOccupationReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/relatorio/visitantes-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={VisitantesRestauranteReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: 'relatorio/visitantes-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={VisitantesRestauranteReportPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grafico/:indicatorId',
        element: <GraphicElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'grafico/:indicatorId',
        element: <GraphicElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grafico/ocupacao-restaurante',
        element: <RouteElement _protected needCompany Component={RestaurantGraphicPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'grafico/ocupacao-restaurante',
        element: <RouteElement _protected needCompany Component={RestaurantGraphicPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/grafico/ocupacao-sala',
        element: <SantanderGraphicElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'grafico/ocupacao-sala',
        element: <SantanderGraphicElement />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/andares',
        element: <RouteElement _protected needCompany Component={AreasPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/andares',
        element: <RouteElement _protected needCompany Component={AreasPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/salas',
        element: <RouteElement _protected needCompany Component={RoomsPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/salas',
        element: <RouteElement _protected needCompany Component={RoomsPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/andar',
        element: <RouteElement _protected needCompany Component={AreaPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/andar',
        element: <RouteElement _protected needCompany Component={AreaPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/andar/:id',
        element: <RouteElement _protected needCompany Component={AreaPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/andar/:id',
        element: <RouteElement _protected needCompany Component={AreaPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/sala',
        element: <RouteElement _protected needCompany Component={RoomPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/sala',
        element: <RouteElement _protected needCompany Component={RoomPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/sala/:id',
        element: <RouteElement _protected needCompany Component={RoomPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/sala/:id',
        element: <RouteElement _protected needCompany Component={RoomPage}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/alertas',
        element: <RouteElement _protected needCompany Component={AlertsPage} features={[FEATURE.ALERT_LIST.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/alertas',
        element: <RouteElement _protected needCompany Component={AlertsPage} features={[FEATURE.ALERT_LIST.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/config-alertas',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigsPage} features={[FEATURE.CONFIG_ALERT_LIST.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/config-alertas',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigsPage} features={[FEATURE.CONFIG_ALERT_LIST.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/config-alerta',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigPage} features={[FEATURE.CONFIG_ALERT_CREATE.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/config-alerta',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigPage} features={[FEATURE.CONFIG_ALERT_CREATE.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/config-alerta/:configId',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigPage} features={[FEATURE.CONFIG_ALERT_UPDATE.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/config-alerta/:configId',
        element: <RouteElement _protected needCompany Component={IndicatorRangeAlertConfigPage} features={[FEATURE.CONFIG_ALERT_UPDATE.id]}/>,
        errorElement: <NotFoundPage />
    },
    {
        path: '/cadastros/reserva-sala',
        element: <RouteElement _protected needCompany Component={RoomReservationsPage} features={[FEATURE.ROOM_RESERVATION_LIST.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastros/reserva-sala',
        element: <RouteElement _protected needCompany Component={RoomReservationsPage} features={[FEATURE.ROOM_RESERVATION_LIST.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/cadastro/reserva-sala',
        element: <RouteElement _protected needCompany Component={RoomReservationPage} features={[FEATURE.ROOM_RESERVATION_READ.id, FEATURE.ROOM_RESERVATION_CREATE.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastro/reserva-sala',
        element: <RouteElement _protected needCompany Component={RoomReservationPage} features={[FEATURE.ROOM_RESERVATION_READ.id, FEATURE.ROOM_RESERVATION_CREATE.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: '/cadastro/reserva-sala/:id',
        element: <RouteElement _protected needCompany Component={RoomReservationPage} features={[FEATURE.ROOM_RESERVATION_READ.id, FEATURE.ROOM_RESERVATION_UPDATE.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/cadastro/reserva-sala/:id',
        element: <RouteElement _protected needCompany Component={RoomReservationPage} features={[FEATURE.ROOM_RESERVATION_READ.id, FEATURE.ROOM_RESERVATION_UPDATE.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: `:companyId/dashboard/sala-reuniao`,
        element: <RouteElement _protected needCompany Component={DashboardRoomSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: `dashboard/sala-reuniao`,
        element: <RouteElement _protected needCompany Component={DashboardRoomSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: `:companyId/dashboard/sala-reuniao/:salaId`,
        element: <RouteElement _protected needCompany Component={DashboardRoomSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: `dashboard/sala-reuniao/:salaId`,
        element: <RouteElement _protected needCompany Component={DashboardRoomSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/dashboard/restaurantes',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={DashboardRestaurantSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'dashboard/restaurantes/',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={DashboardRestaurantSantanderPage} features={[FEATURE.DASHBOARD_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: ':companyId/dashboard/painel-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={DashboardPainelRestaurantSantanderPage} features={[FEATURE.DASHBOARD_RESTAURANT_USUARIOS_VIEW.id]} />,
        errorElement: <NotFoundPage />
    },
    {
        path: 'dashboard/painel-restaurante',
        element: <RouteElement _protected needCompany onlyThisCompanies={['santander']} Component={DashboardPainelRestaurantSantanderPage} features={[FEATURE.DASHBOARD_RESTAURANT_USUARIOS_VIEW.id]} />,
        errorElement: <NotFoundPage />
    }
]

function HomeElement(){
    const {companyId} = useParams()
    // return <ProtectedRoute company={companyId} needCompany ><PendingRecordsPage companyId={companyId ?? ''}/></ProtectedRoute>
    return <ProtectedRoute 
    company={companyId} 
    needCompany
    >
        <Navigate to="dashboard" replace />
    </ProtectedRoute>
}

function PendingRecordsElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.PENDING_RECORDS_LIST.id]} redirectToWhenNotAllowed={<Navigate to="/" replace />} ><PendingRecordsPage companyId={companyId ?? ''}/></ProtectedRoute>
}

function DashboardElement(){
    const {companyId, dashboardId} = useParams()
    if(dashboardId && dashboardId === DashboardType.restaurantes.id) return <ProtectedRoute company={companyId} needCompany features={[FEATURE.DASHBOARD_VIEW.id]} ><SantanderDashboardPage companyId={companyId} dashboardType={DashboardType.restaurantes.id} /></ProtectedRoute>;
    if(dashboardId && dashboardId === DashboardType.salasReuniao.id) return <ProtectedRoute company={companyId} needCompany features={[FEATURE.DASHBOARD_VIEW.id]}><DashboardRoomOccupationPage companyId={companyId} /> </ProtectedRoute>;
    if(companyId === 'santander-demo' || companyId === 'santander') return <ProtectedRoute company={companyId} needCompany features={[FEATURE.DASHBOARD_VIEW.id]}><DashboardRoomOccupationPage companyId={companyId} /></ProtectedRoute>;
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.DASHBOARD_VIEW.id]} ><DashboardPage companyId={companyId} /></ProtectedRoute>;
}

function CompanyElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.COMPANY_CREATE.id, FEATURE.COMPANY_UPDATE.id, FEATURE.COMPANY_DELETE.id, FEATURE.COMPANY_READ.id]} needAllFeatures ><CompanyPage companyId={companyId}/></ProtectedRoute>
}

function BuildingElement(){
    const {companyId, buildingId} = useParams()
    return <ProtectedRoute company={companyId} features={[FEATURE.BUILDING_UPDATE.id, FEATURE.BUILDING_READ.id]}><BuildingPage id={buildingId} companyId={companyId}/></ProtectedRoute>
}

function BuildingGroupElement(){
    const {companyId, buildingGroupId} = useParams()
    return <ProtectedRoute company={companyId}><BuildingGroupPage companyUsername={companyId} buildingGroupId={buildingGroupId} /></ProtectedRoute>
}

function BuildingGroupsElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.BUILDING_GROUP_LIST.id]}><BuildingGroupsPage companyUsername={companyId}/></ProtectedRoute>
}

function UsersElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany  features={[FEATURE.USER_LIST.id]}><UsersPage companyId={companyId} /></ProtectedRoute>
}

function UserElement(){
    const {userId} = useParams()
    return <ProtectedRoute features={[FEATURE.USER_CREATE.id, FEATURE.USER_READ.id, FEATURE.USER_UPDATE.id]}><UserPage userId={userId}/></ProtectedRoute>
}

function IndicatorsElement(){
    const {companyId, indicatorId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.INDICATOR_RECORD_LIST.id]}><IndicatorsPage companyId={companyId ?? ''} indicatorId={indicatorId ?? ''} /></ProtectedRoute>
}

function IndicatorElement(){
    const {companyId, indicatorId, indicatorRecordId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.INDICATOR_RECORD_READ.id ,FEATURE.INDICATOR_RECORD_CREATE.id, FEATURE.INDICATOR_RECORD_UPDATE.id]}><IndicatorPage companyId={companyId ?? ''} indicatorId={indicatorId ?? ''} indicatorRecordId={indicatorRecordId} /></ProtectedRoute>
}

function ReportsElement(){
    const {companyId, reportId} = useParams()
    if(reportId && reportId !== 'indicadores') return <Navigate to={`/${companyId ? companyId : ''}/relatorio/${reportId}`} replace />
    // if(companyId === 'santander-demo') return <Navigate to="reserva-sala" replace />
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.REPORT_VIEW.id]}><ReportsPage companyId={companyId} reportId={reportId} /></ProtectedRoute>
}

function ReservationReportElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.REPORT_VIEW.id]}><ReservationReportPage companyId={companyId} /></ProtectedRoute>
}

function GraphicElement(){
    const {companyId, indicatorId} = useParams()
    if(companyId === 'santander-demo' || companyId === 'santander') return <Navigate to="reserva-sala" replace />
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.CHART_VIEW.id]}><GraphicPage companyId={companyId} indicatorId={indicatorId} /></ProtectedRoute>
}

function SantanderGraphicElement(){
    const {companyId} = useParams()
    return <ProtectedRoute company={companyId} needCompany features={[FEATURE.CHART_VIEW.id]}><SantanderGraphicPage companyId={companyId} /></ProtectedRoute>
}

type RouteElementProps = {
    _protected?: boolean,
    needCompany?: boolean
    features?: string[],
    needAllFeatures?: boolean,
    Component: React.ElementType,
    onlyThisCompanies?: string[]
}

function RouteElement({_protected, needCompany, features, needAllFeatures, Component, onlyThisCompanies}: RouteElementProps){
    const urlParams = useParams()
    if(_protected){
        return <ProtectedRoute company={urlParams.companyId} onlyThisCompanies={onlyThisCompanies} needCompany={needCompany} features={features} needAllFeatures={needAllFeatures}><Component {...urlParams} /> </ProtectedRoute>
    }else{
        return <Component {...urlParams} />
    }
}